import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/skin/d/aurora.svg'
import _imports_1 from '@/assets/images/skin/d/moon.svg'
import _imports_2 from '@/assets/images/skin/d/head.svg'
import _imports_3 from '@/assets/images/skin/d/tower.svg'
import _imports_4 from '@/assets/images/skin/d/windmill.svg'
import _imports_5 from '@/assets/images/skin/d/crystal.svg'
import _imports_6 from '@/assets/images/skin/d/plane.svg'
import _imports_7 from '@/assets/images/skin/d/river.svg'
import _imports_8 from '@/assets/images/skin/d/purple-rose.svg'
import _imports_9 from '@/assets/images/skin/d/origin-rose.svg'
import _imports_10 from '@/assets/images/skin/d/plant-bottom.svg'
import _imports_11 from '@/assets/images/skin/d/bird.svg'
import _imports_12 from '@/assets/images/skin/d/bird-far.svg'
import _imports_13 from '@/assets/images/skin/d/people-shadow.svg'
import _imports_14 from '@/assets/images/skin/d/people.svg'
import _imports_15 from '@/assets/images/skin/d/plant-right-top.svg'


const _withScopeId = n => (_pushScopeId("data-v-595ae09d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "skin-slot-d",
  skin: "d"
}
const _hoisted_2 = { class: "bg-merge" }
const _hoisted_3 = {
  class: "bg-color",
  ref: "bgColorRef"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-starry-sky" }, null, -1))
const _hoisted_5 = {
  ref: "canvasMeteorRef",
  class: "canvas-meteor-ref"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"aurora\" data-v-595ae09d><img src=\"" + _imports_0 + "\" alt=\"\" data-v-595ae09d></div><div class=\"moon\" data-v-595ae09d><img src=\"" + _imports_1 + "\" alt=\"\" data-v-595ae09d></div><div class=\"head\" data-v-595ae09d><img src=\"" + _imports_2 + "\" alt=\"\" data-v-595ae09d></div>", 3)
const _hoisted_9 = {
  ref: "mountainRef",
  class: "mountain"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"tower-windmill\" data-v-595ae09d><div class=\"tower\" data-v-595ae09d><img src=\"" + _imports_3 + "\" alt=\"\" data-v-595ae09d></div><div class=\"windmill\" data-v-595ae09d><img src=\"" + _imports_4 + "\" alt=\"\" data-v-595ae09d></div></div><div class=\"crystal\" data-v-595ae09d><img src=\"" + _imports_5 + "\" alt=\"\" data-v-595ae09d></div>", 2)
const _hoisted_12 = { class: "bg-plane" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_6 + "\" width=\"100%\" height=\"100%\" alt=\"\" data-v-595ae09d><div class=\"bg-plane-river\" data-v-595ae09d><img src=\"" + _imports_7 + "\" alt=\"\" data-v-595ae09d></div><div class=\"purple-rose\" data-v-595ae09d><img src=\"" + _imports_8 + "\" alt=\"\" data-v-595ae09d></div><div class=\"origin-rose\" data-v-595ae09d><img src=\"" + _imports_9 + "\" alt=\"\" data-v-595ae09d></div><div class=\"plant-bottom\" data-v-595ae09d><img src=\"" + _imports_10 + "\" alt=\"\" data-v-595ae09d></div><div class=\"bird\" data-v-595ae09d><img src=\"" + _imports_11 + "\" alt=\"\" data-v-595ae09d></div>", 6)
const _hoisted_19 = {
  ref: "distantRiverRef",
  class: "distant-river"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bird-far" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_12,
    alt: ""
  })
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "people" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "people-shadow" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_13,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_14,
    alt: ""
  })
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "plant-right-top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_15,
    alt: ""
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createElementVNode("div", {
      ref: "bgRef",
      class: "bg",
      style: _normalizeStyle(_ctx.phoneStyle)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, null, 512),
          _hoisted_6,
          _createElementVNode("div", _hoisted_9, null, 512),
          _hoisted_10
        ], 512),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_19, _hoisted_21, 512),
          _hoisted_22
        ]),
        _hoisted_23
      ])
    ], 4)
  ]))
}